<div class="insurance-regular-driver__block">
    <ins-insurance-regular-driver-data
        [purchasedProduct]="purchasedProduct"
        [(openedDriverForm)]="openedDriverForm"
    ></ins-insurance-regular-driver-data>
    <ins-insurance-regular-driver-future [purchasedProduct]="purchasedProduct"></ins-insurance-regular-driver-future>

    <wuc-balloon *ngIf="openedDriverForm" [arrowPosition]="(isScreenSmall$ | async) ? 'topLeft' : 'topRight'" padding="large" [isFullWidth]="true">
        <ins-insurance-regular-driver-form
            [purchasedProduct]="purchasedProduct"
        ></ins-insurance-regular-driver-form>
    </wuc-balloon>
</div>
